import React from 'react';
import {connect} from "react-redux";
import KidsLifeSlider from "src/components/TDP/FrontSliders/KidsLifeSlider";
import store from 'src/store';
import SmallScreenMenuPage from "./HomePage/SmallScreenMenuPage";
import {smallScreenSizes} from "../../datamodels/gameTime";

//const defaultStyle={height:"100%",width:"100vw",paddingLeft:0,marginLeft:-16};

const TDPHome = (props) => {
    let stateData = store.getState();
    let mod = smallScreenSizes.indexOf(stateData.appSettings.breakpoint) > -1
        ? <SmallScreenMenuPage height={props.height}/>
        : <SmallScreenMenuPage height={props.height}/>
        //<KidsLifeSlider height={props.height}/>;
    return (
        <div id="TDPHomeContainer">
            {mod}
        </div>
    )
};
//<NewsLetterSignUp/>
const mapStateToProps = (state) =>{
    return {
        appSettings:state.appSettings,
        gameTime:state.gameTime,
        currentActivityData:state.currentActivityData,
        webSocketData:state.webSocketData

    };
};

export default connect(mapStateToProps,{})(TDPHome);
